import React from "react";
import { useWatch } from "react-hook-form";

import { AutoFormFieldProps } from "@autoform/react";

import { Checkbox } from "@/components/ui/checkbox";

import { Label } from "../../label";

export const BooleanField: React.FC<AutoFormFieldProps> = ({
  field,
  label,
  id,
  inputProps,
}) => {
  const value = useWatch({ name: id });
  return (
    <div className="flex items-center space-x-2">
      <Checkbox
        onCheckedChange={(checked) => {
          // react-hook-form expects an event object
          const event = {
            target: {
              name: id,
              value: checked,
            },
          };
          inputProps.onChange(event);
        }}
        checked={value}
      />
      <Label htmlFor={id}>
        {label}
        {field.required && <span className="text-destructive"> *</span>}
      </Label>
    </div>
  );
};
